import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { SharePanelMode } from "../../Panels/CMFileSharePanel";

export function useMenuItem_CopyLink(selectedItems: any[], openSharePanel: (mode: SharePanelMode) => void) {
  const languageStrings = React.useContext(LanguageContext);

  const tenantSharingEnabled = useSelector((state: RootState) => state.tenantInfo?.enableSharing);

  const [menuItem_CopyLink, setMenuItem_CopyLink] = React.useState<IContextualMenuItem>();

  React.useEffect(() => {
    if (selectedItems?.length > 0 && tenantSharingEnabled) {
      setMenuItem_CopyLink(
        {
          key: "copyLink",
          iconProps: { iconName: "Link" },
          text: `${languageStrings.CopyLink}`,
          onClick: () => openSharePanel(SharePanelMode.Copy)
        }
      );
    }
    else {
      setMenuItem_CopyLink(null);
    }
  }, [selectedItems, tenantSharingEnabled]);

  return {
    menuItem_CopyLink
  }
}